import { useQueryClient } from "@tanstack/react-query";
import { useCallback } from "react";

import Sidebar from "~/components/Sidebar";
import { All_PENDING_INVOICES_QUERY_KEY } from "~/modules/billing/api/pendingInvoice/pendingInvoiceQueries.ts";
import type { PendingInvoicesIndexResponse } from "~/modules/billing/api/unprocessedInvoicesTypes.ts";
import type { InvoiceCommentData } from "~/modules/billing/components/unprocessedInvoicesTableTypes.ts";
import UpdateUnprocessedInvoiceCommentForm from "~/modules/billing/components/UpdateUnprocessedInvoiceCommentForm";

type Props = {
	invoiceCommentData?: InvoiceCommentData;
	isOpen: boolean;
	onClose: () => void;
	userCanManageInvoices: boolean;
};

const UpdatePendingInvoiceCommentSidebar = ({
	invoiceCommentData,
	isOpen,
	onClose,
	userCanManageInvoices
}: Props) => {

	const queryClient = useQueryClient();
	const handleSuccess = useCallback(async (comment:string) => {
		if(!invoiceCommentData)return;
		queryClient.setQueryData<PendingInvoicesIndexResponse>(All_PENDING_INVOICES_QUERY_KEY, (oldData) => {
			if (!oldData) return oldData;

			return {
				...oldData,
				openInvoices: oldData.projectInvoices.map(invoice =>
					invoice.id === invoiceCommentData.invoiceId
						? { ...invoice, comment: comment }
						: invoice
				)
			};
		});
		queryClient.refetchQueries({queryKey:All_PENDING_INVOICES_QUERY_KEY});
		onClose();
	}, [invoiceCommentData, onClose, queryClient]);

	return (
		<Sidebar closeOnOutsideClick={false}
				 open={isOpen}
				 setOpen={() => onClose()}>
			{isOpen && !!invoiceCommentData && <UpdateUnprocessedInvoiceCommentForm invoiceComment={invoiceCommentData}
																					onCancel={onClose}
																					onSuccess={handleSuccess}
																					userCanManageInvoices={userCanManageInvoices}
			/>}
		</Sidebar>
	);
};

export default UpdatePendingInvoiceCommentSidebar;
